import { CurrencyCode, Money, currencyMap } from '@percent/utility'
import { PointsRewardsConfiguration } from '@percent/workplace-giving/api/gamification/getGamificationPartnerConfig/getGamificationPartnerConfig.types'

export const resolveRewardMoney = (
  config: PointsRewardsConfiguration | undefined,
  currency: CurrencyCode | undefined,
  points: number | null | undefined
): Money | undefined => {
  if (config?.value?.type !== 'point_equates_reward') {
    return undefined
  }

  if (typeof points !== 'number' || !Number.isFinite(points) || points <= 0) {
    return undefined
  }

  const { pointValue } = config.value
  const unit = (currency ? pointValue.alternativeCurrencyAmounts?.[currency] : undefined) ?? pointValue

  if (typeof unit?.amount !== 'number' || !Number.isFinite(unit.amount) || !currencyMap[unit.currency]) {
    return undefined
  }

  return { amount: Math.round(points * unit.amount), currency: unit.currency }
}
